import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 * @filename src/components/FAQModal/index.tsx
 * @author  tujiawei <jiaweitu@marchthepolo.com>
 * @date 2025-10-15 11:16:32
 */ import { LOCALE_KEYS } from '@/constant/faq';
import List from '@/pages/chatArea/chatBox/ChatBoxBody/MessageList/List';
import TranslateProvider from '@/pages/chatArea/chatBox/ChatBoxBody/MessageList/TranslateProvider';
import { MessageListContext } from '@/pages/chatArea/chatBox/ChatBoxBody/MessageList/context';
import { create, show, useModal } from '@ebay/nice-modal-react';
import { Modal } from 'antd';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import ErrorBoundaryWrapper from '../ErrorBoundaryWrapper';
import RouterErrorFallbackComponent from '@/components/ErrorBoundary';
import aegis from '@/utils/aegis';
const FAQModal = (param)=>{
    let { modalProps, messages } = param;
    const value = useMemo(()=>({
            messageList: messages,
            updateMessageList () {}
        }), []);
    return /*#__PURE__*/ _jsx(Modal, {
        ...modalProps,
        children: /*#__PURE__*/ _jsx("div", {
            className: classNames('flex flex-col bg-[#F3F5F7] p-[16px] rounded-[8px] max-h-[50vh]'),
            children: "abc"
        })
    });
};
export default FAQModal;
const FAQ = create((props)=>{
    const modal = useModal();
    const { t: t1 } = useTranslation();
    return /*#__PURE__*/ _jsx(FAQModal, {
        modalProps: {
            title: t1(LOCALE_KEYS.VIEW_ALL),
            open: modal.visible,
            afterClose: modal.remove,
            onCancel: modal.hide,
            footer: null
        },
        ...props
    });
});
export const showFAQModal = (props)=>{
    show(FAQ, props);
};
let id = 0;
const Content = (props)=>{
    const messageListProviderValue = useMemo(()=>({
            messageList: (props.messages || []).map((item)=>({
                    ...item,
                    id: ++id,
                    messageTime: ((item === null || item === void 0 ? void 0 : item.messageTime) || 0) * 1000
                })).reverse(),
            updateMessageList () {}
        }), [
        props.messages
    ]);
    return /*#__PURE__*/ _jsx(MessageListContext.Provider, {
        value: messageListProviderValue,
        children: /*#__PURE__*/ _jsx(TranslateProvider, {
            children: /*#__PURE__*/ _jsx("div", {
                className: classNames('flex flex-col bg-[#F8F8F8] p-[16px] rounded-[8px] max-h-[50vh] overflow-auto'),
                children: /*#__PURE__*/ _jsx(ErrorBoundaryWrapper, {
                    FallbackComponent: RouterErrorFallbackComponent,
                    onError: (error)=>{
                        try {
                            aegis.error(error);
                            aegis.error({
                                msg: `FAQ message render error\n${JSON.stringify(props.messages)}`
                            });
                        } catch (e) {}
                    },
                    children: /*#__PURE__*/ _jsx(List, {
                        list: messageListProviderValue.messageList
                    })
                })
            })
        })
    });
};
export const useFAQModal = ()=>{
    const [instance, contextHolder] = Modal.useModal();
    const visible = useRef(false);
    return {
        contextHolder,
        show (props) {
            visible.current = true;
            instance.success({
                width: 520,
                title: t(LOCALE_KEYS.VIEW_ALL),
                icon: null,
                closable: true,
                footer: null,
                wrapClassName: '[&_.ant-modal-confirm-paragraph]:max-w-full',
                content: /*#__PURE__*/ _jsx(Content, {
                    ...props
                })
            }).then(()=>{
                visible.current = false;
            }, ()=>{
                visible.current = false;
            }).finally(()=>{
                visible.current = false;
            });
        }
    };
};
